import { useMutation } from "react-query";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseMutationParameters } from "../BaseUseMutationParameters";
import { IMemoModel } from "../../common/models/IMemoModel";
import MemosDataService from "../../services/memos-data-service/MemosDataService";

export type UseDeleteMemoParameters = {
    customerID: number,
    groupID: number,
    offline: boolean
} & BaseUseMutationParameters<void, IMemoModel>;

export function useDeleteMemo({
    customerID,
    groupID,
    offline,
    onError,
    onSuccess
}: UseDeleteMemoParameters) {

    return useMutation<void, RestError, IMemoModel>(
        (memo) => {
            
            return MemosDataService.deleteMemo(
                customerID,
                groupID,
                memo,
                offline
            );
        },
        {
            onError: onError,
            onSuccess: onSuccess
        }
    );
}